<template>
  <div>
    <CCardHeader class="grey-header d-flex mob-flex-column ai-center">
      <CRow class="flex-flow-column">
        <CCol>
          <span>{{ $t("markUp.title") }}</span>
        </CCol>

        <p class="desc">{{ $t("markUp.desc") }}</p>
      </CRow>
      <CButton
        @click="navToNew(null)"
        size="sm"
        color="success"
        class="ml-auto btn-lit-blue mob-w100"
        >{{ $t("markUp.addNew") }}</CButton
      >
    </CCardHeader>
     <CCardBody class="card assign pricing-card">
    <div >
      <div class="row ">
        <div class="col">
            <div class="row">
              <div class="col-12">
                <label>{{ $t("markUpNew.supplier") }}</label>
                <div class>
                  <multiselect
                    :searchable="true"
                    :close-on-select="true"
                    :track-by="'id'"
                    :label="'name'"
                    :allow-empty="false"
                    v-model="supplier"
                    :show-labels="false"
                    :options="lsSupplierGroup"
                    @input="onSupplierChange"
                    :placeholder="$t('markUpNew.suppPlc')"
                  >
                    <template slot="option" slot-scope="props"
                      ><span> {{ props.option.name }}</span>
                      <!-- <strong class="right ml-auto">{{
                        props.option.id
                      }}</strong> -->
                    </template>
                    <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                  </multiselect>
                </div>
              </div>
            </div>
          </div>

        <div v-if="lsHotels" class="col">
          <!-- <div class="row"> -->
            <!-- <div class="col-12"> -->
              <label>{{ $t("markUpNew.hotel") }}</label>
              <div class>
                <multiselect
                  :searchable="true"
                  :close-on-select="true"
                  :track-by="'hotelid'"
                  :label="'hotelName'"
                  :allow-empty="false"
                  v-model="hotel"
                  :show-labels="false"
                  :options="lsHotels"
                  :custom-label="getHotelNameId"
                  v-on:input="onChangeHotel"
                  :placeholder="'Select Hotel'"
                >

                  <template slot="singleLabel" slot-scope="{ option }"
                          >{{ option.hotelName }}</template
                        >
                  <template slot="option" slot-scope="props"
                    ><span> {{ props.option.hotelName }}</span>
                    <strong class="right ml-auto">{{
                      props.option.hotelid
                    }}</strong>
                  </template>
                  <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                </multiselect>
              </div>
            <!-- </div> -->
          <!-- </div> -->
        </div>

        <div v-if="lsRooms" class="col">
          <div class="row">
            <div class="col-12">
              <label>{{ $t("markUpNew.room") }}</label>
              <div class>
                <multiselect
                  :searchable="true"
                  :close-on-select="true"
                  :track-by="'roomid'"
                  :label="'roomname'"
                  :allow-empty="false"
                  v-model="room"
                  :show-labels="false"
                  :options="lsRooms"
                  :placeholder="'Select Room'"
                  :custom-label='getHotelRoomId'
                >
                  <!-- <template slot="singleLabel" slot-scope="props">
                             <span> {{ props.option.roomname }}</span> 
                             <strong class="right ml-auto">{{
                  props.option.roomid
                }}</strong> </template> -->
                          
                                <template slot="singleLabel" slot-scope="{ option }"
                          >{{ option.roomname }}</template
                        >
                     <template #noOptions>
                              <div>
                                     <span slot="noResult"><strong>
                              {{
                              
                           hotel?
                               $t("noMatchFound.noMatchFound"):$t('markUpNew.noHotels') }}</strong></span>

                              </div>
                            </template>
                  <template slot="option" slot-scope="props"
                    ><span> {{ props.option.roomname }}</span>
                    <strong class="right ml-auto">{{
                      props.option.roomid
                    }}</strong>
                  </template>
                  <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                </multiselect>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="row">
            <div class="col-12">
              <label>{{' '}}</label>
              <div class>
              <CButton @click="onApply">
                Apply
              </CButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div v-if="markUpLs && markUpLs.length > 0">
        <CCardBody
          class="card assign pricing-card"
          v-for="(markup, index) in markUpLs"
          :key="index"
        >
          <table       @click.stop="markup.canEdit?navToNew(markup):null">
            <thead>
              <tr>
                <th>
                  <span>{{ $t("markUp.supplier") }}</span>
                </th>
                <th>
                  <span>{{ $t("markUp.hotel") }}</span>
                </th>
                <th>
                  <span>{{ $t("markUp.room") }}</span>
                </th>
                <th>
                  <span>{{ $t("markUp.stayDate") }}</span>
                </th>

                <th>
                  <span>{{ $t("markUp.value") }}</span>
                </th>
               
                <th>
                  <span>{{ $t("markUp.applicableDay") }}</span>
                </th>
                  <th>
                  <span>{{ $t("markUp.status") }}</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div v-if="markup.supplierGroup && markup.supplierGroup.name">
                    <div>{{ markup.supplierGroup.name }}</div>
                  </div>
                  <div v-else>{{ "-" }}</div>
                </td>
                <td>
                  <div v-if="markup.hotel && markup.hotel.hotelName">
                    <div>{{ markup.hotel.hotelName }}</div>
                  </div>
                  <div v-else>{{ $t("markUp.all") }}</div>
                </td>
                <td>
                  <div v-if="markup.room && markup.room.roomname">
                    <div>{{ markup.room.roomname }}</div>
                  </div>
                  <div v-else>{{ $t("markUp.all") }}</div>
                </td>
                <td>
                  <div v-if="markup.stayfrom">
                    <div>
                      {{ markup.stayfrom| formatDate(DATE_TIME_FORMAT.REPORT_DATE_FORMAT)}}{{' to '}}
                      {{markup.stayto| formatDate(DATE_TIME_FORMAT.REPORT_DATE_FORMAT)}}
                    </div>
                  </div>
                  <div v-else>{{ "-" }}</div>
                </td>

                <td>
                  <div v-if="markup.markupvalue">
                    <div v-if="markup.pricingType == 'PERC'">
                      {{ markup.markupvalue + "%" }}
                    </div>
                    <div v-else>
                      {{ markup.currency?markup.currency : " " }} {{  markup.markupvalue |formatNumber(markup.currency) }}
                    </div>
                  </div>
                  <div v-else>{{ "-" }}</div>
                </td>

            
                <td>
                  <div
                    v-if="
                      markup.applicableDays && markup.applicableDays.length != 0
                    "
                  >
                    <div v-if="markup.applicableDays.length == 7">
                      {{ "All Days" }}
                    </div>
                    <div v-else>{{ markup.applicableDays.toString() }}</div>
                  </div>
                  <div v-else>{{ "-" }}</div>
                </td>

                    <td>
                  <div>
                    <CBadge :color="markup.isactive  ? 'success' : 'danger'">
                      {{ markup.isactive?$t('markUp.active'):$t('markUp.inactive')}}
                    </CBadge>
                  </div>
                </td>
                <!-- <td>
                  <div v-if="markup.applicableDays.length==7">
                    <div>{{$t("markUp.allDays")}}</div>
                  </div>
                  <div v-else-if="markup.applicableDays">
                    <span v-for="(day,index) in markup.applicableDays" :key="index">{{day}}</span>
                  </div>
                  <div v-else>{{'-'}}</div>
                </td> -->
                <td>
                  <CRow>
                    <CCol>
                      <div
                        v-if="markup.canEdit"
                        @click.stop="navToNew(markup)"
                        col="2.5"
                        class="edit-icon icon-25px c-pointer"
                        color="info removewrap"
                        v-c-tooltip.hover="{ content: 'Edit', active: false }"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="512pt"
                          viewBox="0 0 512 512"
                          width="512pt"
                          style="fill: #3c4b64"
                        >
                          <path
                            d="m368 511.957031h-309.332031c-32.363281 0-58.667969-26.304687-58.667969-58.667969v-309.332031c0-32.363281 26.304688-58.667969 58.667969-58.667969h181.332031c8.832031 0 16 7.167969 16 16 0 8.832032-7.167969 16-16 16h-181.332031c-14.699219 0-26.667969 11.96875-26.667969 26.667969v309.332031c0 14.699219 11.96875 26.667969 26.667969 26.667969h309.332031c14.699219 0 26.667969-11.96875 26.667969-26.667969v-181.332031c0-8.832031 7.167969-16 16-16s16 7.148438 16 16v181.332031c0 32.363282-26.304688 58.667969-58.667969 58.667969zm0 0"
                          />
                          <path
                            d="m187.136719 340.820312c-4.203125 0-8.300781-1.664062-11.308594-4.691406-3.796875-3.777344-5.417969-9.21875-4.371094-14.445312l15.082031-75.433594c.617188-3.113281 2.152344-5.953125 4.371094-8.171875l220.953125-220.925781c22.867188-22.871094 60.074219-22.871094 82.964844 0 11.070313 11.070312 17.171875 25.792968 17.171875 41.472656s-6.101562 30.398438-17.195312 41.472656l-220.925782 220.949219c-2.21875 2.238281-5.078125 3.753906-8.171875 4.371094l-75.414062 15.082031c-1.046875.214844-2.113281.320312-3.15625.320312zm75.433593-31.082031h.214844zm-45.609374-52.457031-9.410157 47.144531 47.125-9.429687 217.515625-217.511719c5.035156-5.058594 7.808594-11.734375 7.808594-18.859375s-2.773438-13.804688-7.808594-18.859375c-10.367187-10.390625-27.285156-10.390625-37.714844 0zm0 0"
                          />
                          <path
                            d="m453.332031 134.976562c-4.09375 0-8.191406-1.558593-11.304687-4.695312l-60.332032-60.351562c-6.25-6.25-6.25-16.382813 0-22.632813s16.382813-6.25 22.636719 0l60.328125 60.351563c6.25 6.25 6.25 16.382812 0 22.632812-3.136718 3.117188-7.230468 4.695312-11.328125 4.695312zm0 0"
                          />
                        </svg>
                      </div>
                    </CCol>

                    <CCol>
                      <div
                        @click.stop="toDeleteMarkup(markup)"
                        col="2.5"
                        size="sm"
                        color="danger"
                        v-c-tooltip.hover="{ content: 'Delete', active: false }"
                        class="icon-25px c-pointer"
                      >
                        <CIcon
                          style="color: #cd0606; font-size: 22px"
                          name="cil-trash"
                          size="lg"
                        ></CIcon>
                      </div>
                    </CCol>
                  </CRow>
                </td>
              </tr>
            </tbody>
          </table>
        </CCardBody>
      </div>
      <div v-else class="text-center my-5">
      <div v-if="isLoading" data-v-211fa86d="" role="status" aria-hidden="false" class="spinner-grow spinner-grow-lg text-primary" aria-label="Loading"></div>

        <h4 v-else-if="(hotel || room || supplier)"><strong>{{ $t("markUp.markupEmpty") }}</strong></h4>
        <h4 v-else><strong>{{ $t("markUp.noMarkup") }}</strong></h4>
      </div>
    </div>
     </CCardBody>
    <cAlertModal
      v-if="isShowAlertModal"
      :key="'markups' + alertCount"
      :buttonList="modalButton"
      :status="modalStatus"
      :isShowIcon="true"
      :show="isShowAlertModal"
      :desc="confirmTxt"
    ></cAlertModal>
  </div>
</template>
<script>
import cReviewHotel from "../../../components/hms/cReviewHotel";
import router, { navigate } from "../../../router/index";
import {
  COMPONENT_NAME,
  PATHNAME,
  DEFAULT_DROPDOWN_STATUS,
  ALERT_MODAL_STATUS,
  DATE_TIME_FORMAT, ORDER
} from "../../../util/constants";
import BaseConfiguration from "../../../config/base.js";
import Logger from "../../../services/logger";
import SERVICE_URL, { LOG_TYPE, HTTP_CODES } from "../../../config/API_DATA";
import { mapGetters, mapActions } from "vuex";
import cRoomInfoBox from "../../../components/hms/manage/hotelInfo/cRoomInfoBox";
import apiGetHotelMarkup from "../../../services/apiGetHotelMarkup";
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage,
} from "../../../util/apiValidate";
import multiselect from "vue-multiselect";
import { getErrorAlertValue, handleJWT, 
  addClassToBody,
  removeClassBody, cloneDeep, OrderByList} from "../../../util/util";
import cAlertModal from "../../../components/form/cAlertModal";
import Vue from "vue";
import apiDeleteHotelMarkup from "../../../services/apiDeleteHotelMarkup";
import apiGetAllHotels from "../../../services/apiGetAllHotels";
import apiGetSupplierGroup from "../../../services/apiGetSupplierGroup.js";
import apiGetHotelRooms from "../../../services/apiGetHotelRooms";
export default {
  name: COMPONENT_NAME.MARKUP_ALL,

  components: {
    cReviewHotel,
    cRoomInfoBox,
    cAlertModal,
    multiselect,
  },
  data: () => {
    return {
      markUpLs: [],
      alertCount: 0,
      modalStatus: ALERT_MODAL_STATUS.INFO,
      modalButton: null,
      isShowAlertModal: false,
      confirmTxt: null,
      alertCount: 0,
      lsSupplierGroup: [],
      lsHotels: [],
      lsRooms: [],
      supplier: null,
      hotel: null,
      room: null,
      isLoading:true,
    };
  },
  computed: {
    ...mapGetters("shmsManage", {
      sHotelObj: "GET_SEL_HOTEL",
      
      GET_HOTEL_LS: "GET_HOTEL_LS"
  
    }),
    ...mapGetters("shmsMarkup", {
      GET_MARKUP_LS: "GET_MARKUP_LS",
    }),
    ...mapGetters("sHotelInfo", {
      sRoomObj: "GET_HOTEL_ROOM_OBJ",
    }),
    DATE_TIME_FORMAT() {
      return DATE_TIME_FORMAT;
    },
    ...mapGetters("sSupplierGrp", {
      GET_SUPPLIER_GRP_LS: "GET_SUPPLIER_GRP_LS",
    }),
  },
  created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");
      this.toGetMarkupList();
    } catch (err) {
      let body = Logger.buildRequest(
        COMPONENT_NAME.MARKUP_ALL,
        "error in created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
  methods: {
    ...mapActions("shmsMarkup", {
      SET_SEL_MARKUP: "SET_SEL_MARKUP",
      SET_MARKUP_LS: "SET_MARKUP_LS",
    }),

    ...mapActions("sSupplierGrp", {
      SET_SUPPLIER_GRP_LS: "SET_SUPPLIER_GRP_LS",
    }),

    ...mapActions("shmsManage", {
      SET_HOTEL_LS: "SET_HOTEL_LS",
    }),

    getHotelRoomId({roomname,roomid})
    {
       return `${roomname} — [${roomid}]`
    }
,

      getHotelNameId({hotelName,hotelid})
      {


 return `${hotelName} — [${hotelid}]`
      },

    onSupplierChange(pSupplierObj) {
        try {
          if(BaseConfiguration.isDebug) console.log("onSupplierChange");

          if(this.GET_HOTEL_LS && this.GET_HOTEL_LS.length)
          {

            if(pSupplierObj.id==DEFAULT_DROPDOWN_STATUS.ALL)
            {
            this.lsHotels=cloneDeep(this.GET_HOTEL_LS)
            }
            else
            {
            this.lsHotels=this.GET_HOTEL_LS.filter(hotel=> hotel.supplierGroupId == pSupplierObj.id ) 
            }
           this.lsHotels.unshift(  { hotelName: DEFAULT_DROPDOWN_STATUS.ALL, hotelid: "All" })
            if(this.hotel && ! this.lsHotels.some(hotel=>hotel.hotelid==this.hotel.hotelid))
            {
                       this.hotel=null
                       this.room=null
            }
            
          }
         
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.MARKUP_ALL,
                  "error in onSupplierChange",
                  err.toString(),
                  "onSupplierChange",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
        }, 

    onApply() {
        try {
          if(BaseConfiguration.isDebug) console.log("onApply");
          if (this.supplier && this.supplier.name != DEFAULT_DROPDOWN_STATUS.ALL) {
          this.getSelSupplierGrp(this.supplier)
          }
           if (this.hotel && this.hotel.hotelName != DEFAULT_DROPDOWN_STATUS.ALL) {
         this.getSelHotel(this.hotel)
           }
            if (this.room && this.room.roomname != DEFAULT_DROPDOWN_STATUS.ALL) {
         this.getSelRoom(this.room)
            }
            if(this.supplier && this.supplier.name == DEFAULT_DROPDOWN_STATUS.ALL && 
            this.hotel && this.hotel.hotelName == DEFAULT_DROPDOWN_STATUS.ALL && this.room && this.room.roomname == DEFAULT_DROPDOWN_STATUS.ALL ) {
              this.markUpLs = this.GET_MARKUP_LS;
            }
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.MARKUP_ALL,
                  "error in onApply",
                  err.toString(),
                  "onApply",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          
    }, 

    async toGetMarkupList() {
      try {
        if (BaseConfiguration.isDebug) console.log("toGetMarkupList");
        let suppall = {
          name: DEFAULT_DROPDOWN_STATUS.ALL,
          id: "All",
        }
        let hotelall = {
          hotelName: DEFAULT_DROPDOWN_STATUS.ALL,
          hotelid: "All",
        }
         
         if (this.GET_SUPPLIER_GRP_LS) {
        this.lsSupplierGroup = cloneDeep(this.GET_SUPPLIER_GRP_LS);
      } else {
        this.lsSupplierGroup = cloneDeep(await this.getAllSupplierGroups());
      }
      
      this.markUpLs = await this.getHotelMarkupList(null,true);
         
         var isAll = [];
           isAll = this.lsSupplierGroup.filter(function(supp){
              if(supp.id == "All") return supp;
          });
          if(isAll.length==0){
             this.lsSupplierGroup.unshift(suppall);
          }

       if (this.GET_HOTEL_LS) {
        this.lsHotels = cloneDeep(this.GET_HOTEL_LS);
      } else {
        this.lsHotels = cloneDeep(await this.getallHotelss());
      }
      var isAll = [];
           isAll = this.lsHotels.filter(function(hotel){
              if(hotel.hotelid == "All") return hotel;
          });
          if(isAll.length==0){
             this.lsHotels.unshift(hotelall);
          }
      
        // if(this.markUpLs && this.markUpLs.length!=0){
        // this.toGetDpOptions(this.markUpLs);
        // }
        this.isShowAlertModal = false
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MARKUP_ALL,
          "error in toGetMarkupList",
          err.toString(),
          "toGetMarkupList",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

      async getHotelRooms(pHotel) {
      let retValue;
      
      try {
        if (BaseConfiguration.isDebug) console.log("getHotelRooms");
        if (pHotel) {
          let hotelRoomsReq = apiGetHotelRooms.buildRequest(pHotel.hotelid);

          if (hotelRoomsReq) {
            let hotelRoomsRes = await apiGetHotelRooms.getResponse(
              hotelRoomsReq
            );

            if (VALIDATE_SUCCESS_RES(hotelRoomsRes)) {
              retValue = hotelRoomsRes.data.data.list;
              
            } else {
              let error = getErrorMessage(hotelRoomsRes);
              let isJwt = handleJWT(error);
              if (!isJwt) {
                getErrorAlertValue(error);
              }
            }
          }
        } else {
          throw "invalid hotel obj";
        }
      } catch (err) {
        let body = Logger.buildRequest(
         COMPONENT_NAME.MARKUP_ALL,
          "error in getHotelRooms",
          err.toString(),
          "getHotelRooms",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },


    async getallHotelss() {
      let returnValue;
      try {
        this.isShowAlertModal = false;
        if (BaseConfiguration.isDebug) console.log("getallHotelss");

        let allHotelsRequest = apiGetAllHotels.buildRequest();

        if (allHotelsRequest != null) {
          let allHotelsResponse = await apiGetAllHotels.getResponse(
            allHotelsRequest
          );
          if (VALIDATE_SUCCESS_RES(allHotelsResponse)) {
            returnValue = allHotelsResponse.data.data.list;

            returnValue.forEach((hotel) => {
              hotel["country"] = this.$options.filters.hmsCountryName(
                hotel.countryCode
              );
              hotel["city"] = this.$options.filters.hmsCityName(hotel.cityCode);
              if (hotel.supplierGroup)
                hotel.supplierName = hotel.supplierGroup.name;
              else hotel.supplierName = "";
            });
            this.SET_HOTEL_LS(returnValue);
          } else {
            let error = getErrorMessage(allHotelsResponse);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              let alertValue = getErrorAlertValue(error);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_ALL,
          "error in  get All Users",
          err.toString(),
          "getallHotelss",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

    async getAllSupplierGroups() {
      let returnValue = [];
      try {
        this.isShowAlertModal = false;
        if (BaseConfiguration.isDebug) console.log("getAllSupplierGroups");

        let allSupplierGroupRequest = apiGetSupplierGroup.buildRequest();

        if (allSupplierGroupRequest) {
          let allSupplierGroupResponse = await apiGetSupplierGroup.getResponse(
            allSupplierGroupRequest
          );
          if (VALIDATE_SUCCESS_RES(allSupplierGroupResponse)) {
            returnValue = allSupplierGroupResponse.data.data.list;
            this.SET_SUPPLIER_GRP_LS(returnValue);

            this.alertValue = null;
          } else {
            let error = getErrorMessage(allSupplierGroupResponse);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
         COMPONENT_NAME.MARKUP_ALL,
          "error in  get All Users",
          err.toString(),
          "getAllSupplierGroups",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

    async getSelSupplierGrp(pSupplierObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("getSelSupplierGrp");
        if (pSupplierObj) {
          this.supplier = pSupplierObj;
          // this.hotel = null;
          // this.room=null;
        }
        if(this.supplier && this.supplier.id!='All'){
        this.markUpLs = await this.getHotelMarkupList(this.supplier.id,false);
        }
         
        // if(this.markUpLs && this.markUpLs.length!=0){
        // this.toGetDpOptions(this.markUpLs);
        // }
        let filterLs = this.GET_MARKUP_LS;
        filterLs = filterLs.filter((item) => {
          if (this.supplier && this.supplier.name == DEFAULT_DROPDOWN_STATUS.ALL) {
            return true;
          } else if (
            item.supplierGroup && pSupplierObj && 
            item.supplierGroup.id == pSupplierObj.id
          ) {
            return true;
          }
        });
        if (this.hotel && filterLs.length != 0) {
          filterLs = filterLs.filter((item) => {
            if (this.hotel.hotelName == DEFAULT_DROPDOWN_STATUS.ALL) {
              return true;
            } else if (item.hotel && item.hotel.hotelid == this.hotel.hotelid) {
              return true;
            }
          });
        }
        if (this.room && filterLs.length != 0) {
          filterLs = filterLs.filter((item) => {
            if (this.room.roomname == DEFAULT_DROPDOWN_STATUS.ALL) {
              return true;
            } else if (item.room && item.room.roomid == this.room.roomid) {
              return true;
            }
          });
        }

        this.markUpLs = [];
        this.markUpLs = filterLs;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MARKUP_ALL,
          "error in getSelSupplierGrp",
          err.toString(),
          "getSelSupplierGrp",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

      async onChangeHotel(pHotelObj) {
      try {
          if (BaseConfiguration.isDebug)
              console.log("onChangeHotel");
          let all = {
              roomname: DEFAULT_DROPDOWN_STATUS.ALL,
              roomid: "All",
          }
          if (pHotelObj) {
              this.hotel = pHotelObj;
              this.room = null;

              //to make room all if hotel is all
              if (pHotelObj.hotelid == DEFAULT_DROPDOWN_STATUS.ALL) {
                  this.room = all;
                  this.lsRooms = []
              } else
                  this.lsRooms = cloneDeep(await this.getHotelRooms(this.hotel));
          }

          if (this.lsRooms.length != null) {
              var isAll = [];
              isAll = this.lsRooms.filter(function (rooms) {
                      if (rooms.roomid == "All")
                          return rooms;
                  });
              if (isAll.length == 0) {
                  this.lsRooms.unshift(all);
              }

          }

      } catch (err) {
          let body = Logger.buildRequest(
                  COMPONENT_NAME.MARKUP_ALL,
                  "error in onChangeHotel",
                  err.toString(),
                  "onChangeHotel",
                  LOG_TYPE.ERROR);
          Logger.getResponse(body);
      }

  }, 

    async getSelHotel(pHotelObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("getSelHotel");
        if (pHotelObj) {
          this.hotel = pHotelObj;
          // this.room=null;
          // this.lsRooms = cloneDeep(await this.getHotelRooms(this.hotel));
         
        }
        // let all = {
        //   roomname: DEFAULT_DROPDOWN_STATUS.ALL,
        //   roomid: "All",
        // }
        // if(this.lsRooms.length!=0 ){
        //   var isAll = [];
        //    isAll = this.lsRooms.filter(function(rooms){
        //       if(rooms.roomid == "All") return rooms;
        //   });
        //   if(isAll.length==0){
        //      this.lsRooms.unshift(all);
        //   }
         
        // }
        let filterLs = this.GET_MARKUP_LS;
        filterLs = filterLs.filter((item) => {
            
          if (this.hotel && this.hotel.hotelName == DEFAULT_DROPDOWN_STATUS.ALL) {
              return true;
            } else if (
            item.hotel && pHotelObj &&
            item.hotel.hotelid == pHotelObj.hotelid
          ) {
            return true;
          }
        });
        if (this.supplier && filterLs.length != 0) {
          filterLs = filterLs.filter((item) => {
             if (this.supplier.name == DEFAULT_DROPDOWN_STATUS.ALL) {
              return true;
            } else if (
              item.supplierGroup &&
              item.supplierGroup.id == this.supplier.id
            ) {
              return true;
            }
          });
        }
        if (this.room && filterLs.length != 0) {
          filterLs = filterLs.filter((item) => {
            if (this.room.roomname == DEFAULT_DROPDOWN_STATUS.ALL) {
              return true;
            } else if (
              item.room &&
              item.room.roomid == this.room.roomid
            ) {
              return true;
            }
          });
        }

        this.markUpLs = [];
        this.markUpLs = filterLs;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MARKUP_ALL,
          "error in getSelHotel",
          err.toString(),
          "getSelHotel",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getSelRoom(pRoomObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("getSelRoom");
        if (pRoomObj) {
          this.room = pRoomObj;
        }
        let filterLs = this.GET_MARKUP_LS;
        filterLs = filterLs.filter((item) => {
          if (this.room && this.room.roomname == DEFAULT_DROPDOWN_STATUS.ALL) {
              return true;
            } else if (
            item.room && pRoomObj &&
            item.room.roomid == pRoomObj.roomid
          ) {
            return true;
          }
        });
        if (this.supplier && filterLs.length != 0) {
          filterLs = filterLs.filter((item) => {
            if (this.supplier.name == DEFAULT_DROPDOWN_STATUS.ALL) {
              return true;
            } else if (
              item.supplierGroup &&
              item.supplierGroup.id == this.supplier.id
            ) {
              return true;
            }
          });
        }
        if (this.hotel && filterLs.length != 0) {
          filterLs = filterLs.filter((item) => {
             if (this.hotel.hotelName == DEFAULT_DROPDOWN_STATUS.ALL) {
              return true;
            } else if (
              item.hotel &&
              item.hotel.hotelid == this.hotel.hotelid
            ) {
              return true;
            }
          });
        }

        this.markUpLs = [];
        this.markUpLs = filterLs;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MARKUP_ALL,
          "error in getSelRoom",
          err.toString(),
          "getSelRoom",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    toGetDpOptions(pMarkup) {
      try {
        if (BaseConfiguration.isDebug) console.log("toGetDpOptions");
       
       
       
        for (let i = 0; i < pMarkup.length; i++) {
          // if (pMarkup[i].supplierGroup) {
          //   this.lsSupplierGroup.push(pMarkup[i].supplierGroup);
          // }
          // if (pMarkup[i].hotel) {
          //   this.lsHotels.push(pMarkup[i].hotel);
          // }
          if (pMarkup[i].room) {
            this.lsRooms.push(pMarkup[i].room);
          }
        }
        // this.lsSupplierGroup = Array.from(
        //   new Set(this.lsSupplierGroup.map(JSON.stringify))
        // ).map(JSON.parse);
        // this.lsHotels = Array.from(
        //   new Set(this.lsHotels.map(JSON.stringify))
        // ).map(JSON.parse);
       this.lsRooms = Array.from(
           new Set(this.lsRooms.map(JSON.stringify))
        ).map(JSON.parse);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MARKUP_ALL,
          "error in toGetDpOptions",
          err.toString(),
          "toGetDpOptions",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    showAlertModal(status, val, pParam) {
      this.isShowAlertModal = true;
      this.alertCount += 1;
      this.modalStatus = status;
      this.confirmTxt = val;

      if (status == ALERT_MODAL_STATUS.INFO) {
        this.modalButton = [
          {
            name: this.$t("markUpNew.noBtn"),
            func: this.toggleShowAlertModal,
          },
          {
            name: this.$t("markUpNew.yesBtn"),
            func: this.deleteMarkup,
            param: pParam ? pParam : null,
          },
        ];
      } else if (status == ALERT_MODAL_STATUS.SUCCESS) {
        this.modalButton = [
          {
            name: this.$t("markUpNew.okBtn"),
            func: this.toGetMarkupList,
          },
        ];
      } else if (status == ALERT_MODAL_STATUS.FAIL) {
        this.modalButton = [
          {
            name: this.$t("markUpNew.okBtn"),
            func: this.toggleShowAlertModal,
          },
        ];
      }
    },
    toggleShowAlertModal() {
      this.isShowAlertModal = !this.isShowAlertModal;
    },

    async deleteMarkup(pParam) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("deleteMarkup");
        let deleteReq = apiDeleteHotelMarkup.buildRequest(pParam,12);

        if (deleteReq) {
          let deleteRes = await apiDeleteHotelMarkup.getResponse(deleteReq);

          if (VALIDATE_SUCCESS_RES(deleteRes)) {
            this.alertValue = null;
            retValue = deleteRes.data.data;
            this.showAlertModal(
              ALERT_MODAL_STATUS.SUCCESS,
              this.$t("markUp.deleteSuccess")
            );
            
          } else {
            let error = getErrorMessage(deleteRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error, true, true);
            }
            this.showAlertModal(ALERT_MODAL_STATUS.FAIL, this.alertValue);
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MARKUP_ALL,
          "error in deleteMarkup",
          err.toString(),
          "deleteMarkup",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    toDeleteMarkup(pMarkupObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("toDeleteMarkup");
        // this.selUserObj = pMarkupObj;
        this.showAlertModal(
          ALERT_MODAL_STATUS.INFO,
          this.$t("markUp.deleteConfirm"),
          pMarkupObj.markupid
        );
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MARKUP_ALL,
          "error in toDeleteMarkup",
          err.toString(),
          "toDeleteMarkup",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },


    getPropToSort(pMarkup) {
       let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("getPropToSort");


          if(pMarkup)
          retValue=pMarkup.supplierGroup.name.toString().toLowerCase() 
    
        } catch (err) {
                let body = Logger.buildRequest(
                    COMPONENT_NAME.MARKUP_ALL,
                  "error in getPropToSort",
                  err.toString(),
                  "getPropToSort",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
        }, 

    async getHotelMarkupList(pSupplierId,toStore) {
      let returnValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getHotelMarkupList");

        let getMarkupReq = apiGetHotelMarkup.buildRequest(pSupplierId);

        if (getMarkupReq) {
          let getMarkupRes = await apiGetHotelMarkup.getResponse(getMarkupReq);
          if (VALIDATE_SUCCESS_RES(getMarkupRes)) {
            this.alertValue = null;
            returnValue = getMarkupRes.data.data.list;
            returnValue  =OrderByList(returnValue,this.getPropToSort,ORDER.ASC)
            if(toStore){
            this.SET_MARKUP_LS(returnValue);
            }
          } else {
            let error = getErrorMessage(getMarkupRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MARKUP_ALL,
          "error in  getHotelMarkupList",
          err.toString(),
          "getHotelMarkupList",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },
    navToNew(pMarkupObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("navToNew");
        if (pMarkupObj) {
          this.SET_SEL_MARKUP(pMarkupObj);
        } else {
          this.SET_SEL_MARKUP(null);
        }
        navigate(PATHNAME.MARKUP_NEW);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MARKUP_ALL,
          "error in navToNew",
          err.toString(),
          "navToNew",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
  },
   beforeCreate() {
    addClassToBody(COMPONENT_NAME.MARKUP_ALL);
  },

  beforeDestroy() {
    removeClassBody();
  }
};
</script>